import RcDrawer from 'rc-drawer';
import React from 'react';
export default class Drawer extends React.Component {
    render() {
        return <RcDrawer {...this.props}/>;
    }
}
Drawer.defaultProps = {
    prefixCls: 'am-drawer',
    enableDragHandle: false,
};



// WEBPACK FOOTER //
// ./components/drawer/index.tsx